export const listInChannels = (channels, key) => {

  if (!channels) return [];

  if (!key || key !== 'rmProcedures' && key !== 'profiles') {
    console.error('🐝 listInChannels: `key` must be `rmProcedures` or `profiles`');
  };

  const list = []

  channels.forEach( channel => {
    channel[key].forEach( item => {
      // find if object already exists in list
      const index = list.findIndex( listItem => listItem.id === item.id );
      if (index === -1) {
        list.push(item)
      }
    })
  })

  return [...new Set(list)]
}